import * as yup from "yup";

// Unutar zagrada smiju stajati tokeni i razdjelnici, pa je i "{ID/DD-YYYY}" ispravno (backend ga
// normalizira u "{ID}/{DD}-{YYYY}", vidi DocumentNumberFormat).
const TOKEN_GROUP_REGEX = /\{([^{}]*)\}/g;
const TOKEN_GROUP_CONTENT_REGEX = /^(YYYY|YY|MM|DD|ID|[-/._ ])+$/;
const TOKEN_ID_REGEX = /ID/;

// Prazan format je dopušten: backend tada koristi "{ID}-{YYYY}".
export const INVOICE_EDIT_FORM_SCHEMA = yup.object().shape({
  invoiceFormatNumber: yup
    .string()
    .nullable()

    .test(
      "only-allowed-tokens",
      "Dozvoljeni su samo tokeni YYYY, YY, MM, DD i ID u vitičastim zagradama, npr. {ID/DD-YYYY} ili {ID}-{YYYY}",
      (value) => {
        if (!value) return true;

        const groups = Array.from(value.matchAll(TOKEN_GROUP_REGEX));

        // mora postojati barem jedna zagrada, i svaka smije sadržavati samo tokene i razdjelnike
        return groups.length > 0
          && groups.every((group) => TOKEN_GROUP_CONTENT_REGEX.test(group[1]));
      }
    )

    // Fiskalizacija traži slijedni redni broj računa, a on se čita iz {ID}.
    .test(
      "contains-id",
      "Format mora sadržavati {ID} (redni broj), npr. {ID}-{YYYY}. Fiskalizacija traži slijedni redni broj računa",
      (value) => {
        if (!value) return true;

        return Array.from(value.matchAll(TOKEN_GROUP_REGEX))
          .some((group) => TOKEN_ID_REGEX.test(group[1]));
      }
    ),
});
